import React from 'react';
import { Close } from '@material-ui/icons'
import { IconButton, makeStyles } from '@material-ui/core';
const useStyles = makeStyles(theme => ({

    btnClose: {
        width: '25px',
        height: '25px',
        border: 'solid 1px #b4b5bd',
        borderRadius:'6px',
        backgroundColor: '#ffffff',
        padding:0
    },

}));

export default function CloseButton({ color, ...props }) {
    const classes = useStyles()
    return (
        <IconButton className={classes.btnClose} {...props}>
            <Close color='primary' />
        </IconButton>
    );
}
